import { render, staticRenderFns } from "./_data-subject.vue?vue&type=template&id=3fc2ee12"
import script from "./_data-subject.vue?vue&type=script&lang=js"
export * from "./_data-subject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports